import { NikeApp } from '@nike/nike-design-system-icons'
import './Footer.css'
import { useOktaAuth } from '@okta/okta-react'
import { useState } from 'react'

import { AppInfoModal } from './AppInfoModal'
import { DcConfigModal } from './DcConfigModal'

export function Footer () {
  const { authState } = useOktaAuth()
  const [showAppInfo, setShowAppInfo] = useState<boolean>(false)
  const [showDcConfig, setShowDcConfig] = useState<boolean>(false)

  return (
    <>
    <div className="footer h-8 z-20">
        <div className="footer-left">
          <button
            className="footer-link"
            onClick={() => {
              setShowDcConfig(true)
            }}
          >
            DC Configuration
          </button>
        </div>
        <div className="footer-center">
          <NikeApp
              title="Nike logo"
              color="black"
              width="56px"
              height="32px"
              onClick={() => {
                setShowAppInfo(true)
              }}
          />
        </div>
    </div>
    { authState?.isAuthenticated && showAppInfo &&
      <AppInfoModal setShowAppInfo={setShowAppInfo}/>
    }
    { showDcConfig && (
      <DcConfigModal setShowModal={setShowDcConfig}/>
    )}
    </>
  )
}
